import {EventEmitter, Injectable, OnDestroy, ViewChild} from '@angular/core';
import {AngularFireDatabase} from 'angularfire2/database';
import {NgForm} from '@angular/forms';
import {Observable, Subscriber, Subscription} from 'rxjs/Rx';
import * as firebase from 'firebase';
import {FirebaseApp} from 'angularfire2';
import {AngularFireStorage} from '@angular/fire/storage';
import {finalize, map} from 'rxjs/operators';
import {WorkoutEventModel} from '../_models/_firebaseObjects/WorkoutEventModel';
import {MemberModel} from '../_models/_firebaseObjects/MemberModel';
import {MemberGroupModel} from '../_models/_firebaseObjects/MemberGroupModel';
import ThenableReference = firebase.database.ThenableReference;
import {GroupMetaData} from '../_models/_metadata/GroupMetaData';
import {reflector} from '@angular/core/src/reflection/reflection';
import {Properties} from '../_utils/properties';
import {MemberMetaData} from '../_models/_metadata/MemberMetaData';
import {PTModel} from '../_models/_firebaseObjects/PTModel';
import {UserModel} from '../_models/_firebaseObjects/UserModel';
import {AuthService} from '../shared/auth/auth.service';
import {User} from 'firebase';
import { UtilsService } from 'app/_utils/utils.service';

@Injectable()
export class UserBoardService implements OnDestroy {
  gym_uid: string;
  gymId: string;
  authStateSubs: Subscription;

  uploadLogoImageEvent = new EventEmitter<string>();
  uploadAdvertImageEvent = new EventEmitter<string>();
  uploadGymEventImageEvent = new EventEmitter<string>();
  uploadProfileImageEvent = new EventEmitter<string>();

  //default image url;
  uploadedFileUrl: string;
  personName: string;

  constructor(
    public db: AngularFireDatabase,
    private storage: AngularFireStorage,
    private authService: AuthService,
    private utilsService: UtilsService) {
    this.gym_uid = localStorage.getItem('gym_uid');
    this.gymId = localStorage.getItem('gym_id');
    this.personName = localStorage.getItem('person_name');
  }

  getGymDetails(): Observable<any> {
    this.gymId = localStorage.getItem('gym_id');
    return this.db.object('gyms/' + this.gymId).valueChanges();
  }

  getAllEvents(): Observable<any> {
    return this.db.list('workouts/' + this.gymId).valueChanges();
  }

  updateGymInfo(gymInfo: any): Promise<void> {
    return this.db.object('gyms/' + this.gym_uid).update(gymInfo);
  }

  pushFileToStorage(file: File, imageUploadPurpose: string) {
    const storageRef = firebase.storage().ref();
    const uploadTask = storageRef.child(
      this.gym_uid + '/' + this.utilsService.guid() + '-' + file.name
    ).put(file);

    uploadTask.on('state_changed', () => {
    }, error => {
    }, () => {
      uploadTask.snapshot.ref.getDownloadURL().then(downloadUrl => {
        this.uploadedFileUrl = downloadUrl;
        if (imageUploadPurpose === Properties.LOGO) {
          this.uploadLogoImageEvent.emit(downloadUrl);
        } else if (imageUploadPurpose === Properties.ADVERTISEMENT) {
          this.uploadAdvertImageEvent.emit(downloadUrl);
        } else if (imageUploadPurpose === Properties.GYM_EVENT) {
          this.uploadGymEventImageEvent.emit(downloadUrl);
        } else if(imageUploadPurpose === Properties.PROFILE_IMAGE) {
          this.uploadProfileImageEvent.emit(downloadUrl);
        }
        console.log(this.uploadedFileUrl);
      });
    });
  }


  deleteEvent(event: WorkoutEventModel) {
    console.log(event.ref);
    return this.db.object('workouts/' + this.gymId + '/' + event.ref).remove();
  }

  broadCastMessage(message: string, dateToSend: any, seconds: any) {
    const newKey = Math.random().toString(36).substr(2, 10);
    const ab = this.db.object('gyms/' + this.gymId + '/globalMessages/' + newKey);
    return ab.set({messageText: message, timeSent: dateToSend, seconds: seconds});
  }

  broadCastMessageToGroups(groupMeta: GroupMetaData, message: string, dateToSend: any, seconds: any) {
    this.db.database.ref('gyms/' + this.gymId + '/groups/' + groupMeta.key).push({
      messageText: message,
      timeSent: dateToSend,
      seconds: seconds
    });
  }

  addFeaturedEvent(event: WorkoutEventModel) {
    console.log('updating...')
    console.log(event);
    if (!event.createdOn) {
      event.createdOn = new Date();
    }
    event.updatedOn = new Date();

    return this.db.list('workouts/' + this.gymId).update(event.ref, event);
  }

  // unused method?
  getFileStorageUrl(file: File) {
    let storageRef = firebase.storage().ref().child(this.gym_uid + '/' + file.name).getDownloadURL().then(x => console.log(x));
    return storageRef;
  }

  fetchMembers(): Observable<any> {
    return this.db.list('users', ref => ref.orderByChild('chosenGym').equalTo(this.gymId)).snapshotChanges().pipe(map(changes => changes.map(c => ({
      key: c.payload.key,
      member: c.payload.val()
    }))));
  }


  addGroup(group: MemberGroupModel): ThenableReference {
    return this.db.database.ref('gyms/' + this.gymId).child('groups').push(group);
  }

  fetchGroups() {
    //return this.db.list('gyms/' + this.gymId + '/groups').valueChanges();//.on("child_added", (snapshot)=> val = snapshot.val());
    return this.db.list('gyms/' + this.gymId + '/groups').snapshotChanges().pipe(map(changes => changes.map(c => ({
      key: c.payload.key,
      value: c.payload.val()
    }))));
  }

  updateGroup(groupMeta: GroupMetaData) {
    return this.db.list('gyms/' + this.gymId + '/groups').update(groupMeta.key, groupMeta.group);
  }

  updateVerifiedGyms(key: string, dataToUpdate: any): Promise<any> {
    // console.log(member);
    // const ab = this.db.object('users/' + key);
    // if(member["ptVerifiedGyms"]) {
    //   return ab.update(member);
    // } else {
    //   this.db.database.ref('users/' + key).child('ptVerifiedGyms').push(ptVerifiedGyms);
    //   member["ptVerifiedGyms"] = ptVerifiedGyms;

    return this.db.database.ref('users/' + key).update(dataToUpdate);

  }

  deleteGroup(groupMeta: GroupMetaData) {
    return this.db.list('gyms/' + this.gymId + '/groups').remove(groupMeta.key);
  }

  fetchGymMembers() {
    return this.db.list('users', ref => ref.orderByChild('chosenGym').equalTo(this.gymId)).valueChanges();
  }

  fetchExperienceLevelsList(): Observable<string[]> {
    return this.db.list('experienceLevels').valueChanges().pipe(map((exp: string[]) => {
      return exp;
    }));
  }

  fetchFitnessGoalsList(): Observable<string[]> {
    return this.db.list('fitnessGoals').valueChanges().pipe(map((exp: string[]) => {
      return exp;
    }));
  }

  sendMessageToTargetedGroups(message: string, dateToSend: string, seconds: string, tag: string): string {
    let dataToAdd = {
      'messageText': message,
      'seconds': seconds,
      'tag': tag,
      'timeSent': dateToSend,
    }
    let ref = this.db.database.ref('gyms/' + this.gymId).child('targetedMessages').push(dataToAdd);
    return ref.key;
  }

  ngOnDestroy(): void {
    this.authStateSubs.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/user-board.service.ts